import { KeyRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { Portal } from '../types'

// Same accounts as backend DemoSeeder::accounts(): demo.<role><n>@schooleduca.com / <role><n>@12345.
const demo = (portal: Portal, label: string, role: string, n = 1) => ({
  portal,
  label,
  email: `demo.${role}${n}@schooleduca.com`,
  password: `${role}${n}@12345`,
})

const accounts: { portal: Portal; label: string; email: string; password: string }[] = [
  demo('admin', 'Super admin', 'admin', 1),
  demo('admin', 'Admin', 'admin', 2),
  demo('admin', 'Accountant', 'staff', 1),
  demo('admin', 'Librarian', 'staff', 2),
  demo('admin', 'Receptionist', 'staff', 3),
  demo('staff', 'Teacher', 'teacher', 1),
  demo('staff', 'Accountant', 'staff', 1),
  demo('family', 'Student', 'student', 1),
  demo('family', 'Parent', 'parent', 1),
]

/** Development-only helper listing the seeded demo accounts (never rendered in production builds). */
export function DemoAccounts({
  portal,
  onPick,
}: {
  portal: Portal
  onPick: (email: string, password: string) => void
}) {
  const { t } = useTranslation('auth')
  const list = accounts.filter((a) => a.portal === portal)
  return (
    <div className="mt-6 rounded-card border border-dashed border-line-strong bg-surface-muted p-4">
      <p className="flex items-center gap-2 text-xs font-semibold text-ink-soft">
        <KeyRound className="size-3.5 text-brand-500" aria-hidden="true" />{' '}
        {t('Demo accounts (development only)')}
      </p>
      <div className="mt-3 flex flex-wrap gap-2">
        {list.map((a) => (
          <button
            key={a.email}
            type="button"
            onClick={() => onPick(a.email, a.password)}
            className="rounded-full border border-line bg-surface px-3 py-1 text-xs font-medium text-ink-soft transition-colors hover:border-brand-300 hover:text-brand-700"
          >
            {t(a.label)}
          </button>
        ))}
      </div>
    </div>
  )
}
